export default function isValidPhoneNumber(num) {
  const regex =
    /((\+*)((0[ -]*)*|((91 )*))((\d{12})+|(\d{10})+))|\d{5}([- ]*)\d{6}/;
  const isValid = regex.test(num);
  // console.log("Phone number validity:", isValid);
  return isValid;
}
